import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";

import { ServiceDetailsShape } from "../../policies/proptypes";
import ActionButton from "../../shared/components/ActionButton";
import { convertObjToJSON, generateKeys } from "../../shared/utils";

class ServiceInstructions extends Component {
  state = {
    keys: generateKeys()
  };

  getProductInstructions = () => {
    const { keys } = this.state;
    const { closeInstructions, saving, service } = this.props;
    const { credentials, name, product } = service;
    const apiUrl = process.env.API_URL || "$API_URL";

    if (product && product.label === "maas") {
      const cliText = `sudo maas configauth --rbac-url ${apiUrl} --rbac-service-name ${name ||
        "$SERVICE_NAME"}`;
      return (
        <Fragment>
          <header className="p-modal__header">
            <h2 className="p-modal__title">
              {`Configure ${product.name} to use RBAC`}
            </h2>
          </header>
          <div className="p-code-copyable" style={{ marginBottom: "1.2rem" }}>
            <input
              className="p-code-copyable__input"
              value={cliText}
              readOnly
            />
            <button
              className="p-code-copyable__action"
              type="button"
              onClick={() => this.handleCopy(cliText)}
            >
              Copy to clipboard
            </button>
          </div>
          <p>
            <i className="p-icon--warning" />
            <span className="p-icon__text">
              {`Only Admin users defined through RBAC can configure ${product.name} to use the service.`}
            </span>
          </p>
          <div className="l-flex-end-centered">
            <button
              className="u-no-margin--bottom"
              type="button"
              onClick={() => closeInstructions()}
            >
              Done
            </button>
          </div>
        </Fragment>
      );
    }

    if (product && product.label === "lxd") {
      if (credentials && credentials.agents) {
        return (
          <Fragment>
            <header className="p-modal__header">
              <h2 className="p-modal__title">
                Copy or download the following credentials
              </h2>
            </header>
            <pre style={{ marginBottom: "1.2rem", position: "relative" }}>
              {convertObjToJSON(service.credentials)}
              <button
                className="p-copy-button p-button--neutral"
                type="button"
                onClick={() =>
                  this.handleCopy(convertObjToJSON(service.credentials))
                }
              />
            </pre>
            <p>
              <button
                type="button"
                className="p-button--link"
                onClick={() => this.handleDownload()}
              >
                <i className="p-icon--download" />
                <span className="p-icon__text">Download credentials</span>
              </button>
            </p>
            <p>
              <i className="p-icon--warning" />
              <span className="p-icon__text">
                RBAC does not store these credentials. Refreshing the browser or
                logging out will require regenerating them.
              </span>
            </p>
            <div className="l-flex-end-centered">
              <button
                className="u-no-margin--bottom"
                type="button"
                onClick={() => closeInstructions()}
              >
                Done
              </button>
            </div>
          </Fragment>
        );
      }

      return (
        <Fragment>
          <header className="p-modal__header">
            <h2 className="p-modal__title">
              {`Use the following key pair to register ${service.name}?`}
            </h2>
          </header>
          <pre>{convertObjToJSON(keys)}</pre>
          <div className="l-flex-end-centered">
            <ActionButton
              className="u-no-margin--bottom"
              type="positive"
              inProgress={saving}
              onClick={() => this.handleRegister()}
            >
              {`Register ${service.name}`}
            </ActionButton>
          </div>
        </Fragment>
      );
    }

    return (
      <Fragment>
        <header className="p-modal__header">
          <h2 className="p-modal__title">Instructions not found</h2>
        </header>
        <p>
          {`Instructions do not exist for configuring RBAC with ${product.name}.`}
        </p>
        <div className="l-flex-end-centered">
          <button
            className="u-no-margin--bottom"
            type="button"
            onClick={() => closeInstructions()}
          >
            Done
          </button>
        </div>
      </Fragment>
    );
  };

  handleClickOutside = e => {
    const { closeInstructions } = this.props;

    if (e.target && e.target.className.includes("l-inner-modal")) {
      closeInstructions();
    }
  };

  handleCopy = value => {
    try {
      const tempTextarea = document.createElement("textarea");
      tempTextarea.value = value;
      document.body.appendChild(tempTextarea);
      tempTextarea.select();
      document.execCommand("copy");
      document.body.removeChild(tempTextarea);
    } catch (error) {
      console.warn(`Unable to copy to clipboard: ${error}`);
    }
  };

  handleDownload = () => {
    const { service } = this.props;
    const { credentials } = service;

    if (credentials && credentials.agents) {
      const formatted = convertObjToJSON(credentials);
      const element = document.createElement("a");
      const file = new Blob([formatted], { type: "text/plain" });
      element.href = URL.createObjectURL(file);
      element.download = "candid-crbs.keys";
      document.body.appendChild(element); // Required for this to work in FireFox
      element.click();
    }
  };

  handleRegister = () => {
    const { keys } = this.state;
    const { registerService, service } = this.props;
    registerService(service, keys);
  };

  render = () => (
    <div
      className="p-modal l-inner-modal"
      onClick={e => this.handleClickOutside(e)}
      onKeyPress={e => this.handleClickOutside(e)}
      role="button"
      tabIndex="0"
    >
      <div className="p-modal__dialog l-inner-modal__dialog">
        {this.getProductInstructions()}
      </div>
    </div>
  );
}

ServiceInstructions.propTypes = {
  closeInstructions: PropTypes.func.isRequired,
  registerService: PropTypes.func.isRequired,
  service: ServiceDetailsShape.isRequired,
  saving: PropTypes.bool
};

ServiceInstructions.defaultProps = {
  saving: undefined
};

export default ServiceInstructions;
